import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import {
  VisibilityRuleService,
  VisibilityRule,
} from '../visibility-rule-service';
import { PeripheralsService } from '../../peripherals/logic/peripherals.service';

@Injectable({
  providedIn: 'root',
})
export class HasPeripheralsVisibilityService implements VisibilityRuleService {
  // Public Member
  public readonly name: VisibilityRule = 'hasPeripherals';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private peripheralsService: PeripheralsService,
  ) {}

  // VisibilityRuleService
  public isVisible(params: any): boolean {
    return (this.peripheralsService.allPeripherals ?? []).length > 0;
  }

  // Private Functions
}
